const MainMenu = {

	initMenuButton: () => {
		let header = document.querySelector('#header')
		let menuButton = document.querySelector('#menu-button')
		menuButton.addEventListener('click', (event) => {
			event.preventDefault();
			event.currentTarget;

			header.classList.toggle('active')

		});
	},


	initParentMenuItems: () => {
		let parentMenuItems = document.querySelectorAll('#main-menu > li.menu-item-has-children')

		if (parentMenuItems.length > 0) {

			parentMenuItems.forEach((parentMenuItem) => {

				parentMenuItem.querySelector('a').addEventListener('click', (event) => {
					event.preventDefault();
					event.currentTarget;

					parentMenuItem.classList.toggle('active')

				});
			})
		}
	},

	init: () => {
		window.addEventListener('load', () => {
			MainMenu.initMenuButton()
			MainMenu.initParentMenuItems()
		}, false);

	}
}

MainMenu.init()